import { Button, Checkbox, Modal, ModalFooter, ModalHeader } from "modules/common";
import React, { useEffect, useState } from "react";
import { Education } from "services";
import { reminders } from "../constants";
import { useAddRemoveEdicationReminder } from "modules/common/hooks/dippHooks";

interface Props {
    education: Education;
    isReminderModalOpen: boolean;
    onClose: () => void;
}

export const EducationReminderModal: React.FC<Props> = ({
    education,
    isReminderModalOpen,
    onClose,
}) => {
    const [localReminders, setLocalReminders] = useState<number[]>([]);

    const addRemoveEducationReminder = useAddRemoveEdicationReminder();

    useEffect(() => {
        if (!isReminderModalOpen) return;
        
        setLocalReminders(education.educationReminders);
    }, [education, isReminderModalOpen]);

    const onConfirm = () => {
        if (!education) return;

        addRemoveEducationReminder.mutateAsync({
            educationId: education.uid,
            remindInDays: localReminders,
        });

        toggleModal();
    };

    const toggleModal = () => {
        setLocalReminders([]);
        onClose();
    };

    return (
        <Modal
            isActive={isReminderModalOpen}
            modalHeader={<ModalHeader onClose={toggleModal} title="Podsjetnik na edukaciju" />}
            onClose={toggleModal}
            modalFooter={
                <ModalFooter>
                    <Button
                        size="xsmall"
                        variant="primary-ghost"
                        className="btn--nowrap mx--auto"
                        onClick={onConfirm}
                    >
                        Potvrdi
                    </Button>
                </ModalFooter>
            }
        >
            <div className="education-reminder-modal">
                {reminders.map(reminder => (
                    <div key={reminder.id}>
                        <Checkbox
                            type="checkbox"
                            htmlFor={`education-${reminder.id}-reminder`}
                            value={reminder.value.toString()}
                            isChecked={localReminders.some(r => r === reminder.value)}
                            onChange={() => {
                                setLocalReminders(prev => {
                                    return prev.find(r => r === reminder.value)
                                        ? prev.filter(r => r !== reminder.value)
                                        : [...prev, reminder.value];
                                });
                            }}
                            text={<div className="filter__item__text">{reminder.label}</div>}
                        />
                    </div>
                ))}
            </div>
        </Modal>
    );
};
